export const PRODUCT_TYPE = 'PRODUCT'
export const ORDER_REQUEST_TYPE = 'ORDER_REQUEST'
